export const PROGRESS_ANIMATION = {
  INITIAL_TARGET: 90,
  INITIAL_DURATION: 2000,
  INITIAL_STEPS: 20,
  COMPLETION_DURATION: 300,
  COMPLETION_STEPS: 10,
  HIDE_DELAY: 200,
} as const;

export const PROGRESS_COMPUTED = {
  INITIAL_STEP_DURATION: PROGRESS_ANIMATION.INITIAL_DURATION / PROGRESS_ANIMATION.INITIAL_STEPS,
  INITIAL_STEP_INCREMENT: PROGRESS_ANIMATION.INITIAL_TARGET / PROGRESS_ANIMATION.INITIAL_STEPS,
  COMPLETION_STEP_DURATION: PROGRESS_ANIMATION.COMPLETION_DURATION / PROGRESS_ANIMATION.COMPLETION_STEPS,
} as const;

export const PROGRESS_ANIMATION_DELAY = PROGRESS_ANIMATION.HIDE_DELAY;

export const PROGRESS_BAR_CONSTANTS = {
  MAX_PROGRESS: 100,
  MIN_PROGRESS: 0,
};
